import { HTTP } from '@/axios_api/http-common' 
import {Milestone} from '../../types/Milestone'
import Vue from 'vue'

const state = {
  milestones: {},
  milestoneChanges:[],
  activityId:"",
}

interface IState {
    milestones: Record<string,Array<any>>
    activityId:string,
    milestoneChanges:Array<any>
}

const getters = {

    getMilestonesForActivity (state: IState) {
      if(!state.activityId)return []
      const activityToReturn = state.milestones[state.activityId]
      if(activityToReturn==undefined)return []
      return activityToReturn
    },

    filteredMilestoneForActivity : (state:IState,getters:any) => (filter:string) => {
      return getters.getMilestonesForActivity.filter((thisMilestone:any) => thisMilestone.name.toLowerCase().match(filter.toLowerCase()))
    },

    getMilestoneChangesCount: (state:IState) => {
      return state.milestoneChanges.length
    },
    
    getMilestoneById:(state:IState) => (id:any) => {
      for(let k in state.milestones){
        let milestone = state.milestones[k].find((thisMilestone:any) => thisMilestone.id==id)
        if(milestone){
          //correct for parent activity id here
          milestone.parentActivityId = k
          return milestone
        } 
      }
      return {}
    },

    convertMilestoneToMilestoneModel:(state:IState,getters:any) => (id:any) => {

      let milestoneModel:any = {}
      let milestoneToConvert = getters.getMilestoneById(id)

      milestoneModel.id = milestoneToConvert.id
      milestoneModel.parentActivityId = milestoneToConvert.parentActivityId
      milestoneModel.code = milestoneToConvert.code
      milestoneModel.name = milestoneToConvert.name
      milestoneModel.start = milestoneToConvert.start
      milestoneModel.end = milestoneToConvert.end
      milestoneModel.selectedOption = milestoneToConvert.selectedOption
      milestoneModel.duration = milestoneToConvert.duration
      milestoneModel.startDepth = milestoneToConvert.startDepth
      milestoneModel.endDepth = milestoneToConvert.endDepth
      milestoneModel.dailyOperations = milestoneToConvert.dailyOperations
      milestoneModel.description = milestoneToConvert.description

      //handle budget updates here
      if(milestoneToConvert.budgetChanged){
        milestoneModel.budget = {
          budgetTemplateId:milestoneToConvert.budget.budgetTemplateId,
          activityId:milestoneToConvert.budget.activityId,
          budgetLines:milestoneToConvert.budget.budgetLines.map((bl:any) => ({
            lineItemId:bl.lineItemId,
            lineValue:bl.lineValue
          }))
        }
      }

      //end of budget update
      return milestoneModel
    }
}

const mutations = {

  setActivityId(state:IState, activityId:any){
    if(state.activityId==activityId)return
    state.activityId = activityId
    if(!state.milestones[state.activityId])Vue.set(state.milestones,state.activityId,[])
  },

  setMilestones(state:IState,data:any){
    Vue.set(state.milestones,state.activityId,data.data)
  },

  addMilestoneToActivity(state: IState, milestoneToAdd: any) {
    let tempId = Math.abs((Math.floor(Math.random() * (10 - +4000))  +10)+(Math.floor(Math.random() * (10 - +4000))  +10)); 
    milestoneToAdd.id = tempId
    milestoneToAdd.parentActivityId = state.activityId
    state.milestones[state.activityId].push(milestoneToAdd) 
    state.milestoneChanges.push({
      id:tempId,
      action:"CREATE",
    })
  },

  updateNewMilestones(state:IState, data:any){
    for(let k in state.milestones){
      state.milestones[k].forEach((thisMilestone,index,milestones) => {
        if(data.data) {
          let indexOfUpdate = data.data.findIndex((thisUpdate:any) => thisUpdate.data.tempKey == thisMilestone.id)
          if(indexOfUpdate>-1)milestones[index] = data.data[indexOfUpdate].data
        }
      })
    }
  },

  updateMilestone (state:IState, milestoneToUpdate:any){
    
    //make sure changes to start and end date are saved to the store
    let existingChangeIndex = state.milestoneChanges.findIndex(thisMilestoneUpdate => thisMilestoneUpdate.id == milestoneToUpdate.id)
    let existingMilestoneIndex = state.milestones[state.activityId].findIndex(thisMilestone => thisMilestone.id == milestoneToUpdate.id)
    
    if(existingChangeIndex<0){
      state.milestoneChanges.push({
        id:milestoneToUpdate.id,
        action:"UPDATE",
      })
    }

    for(let key in milestoneToUpdate){
      if(key=="id")continue
      state.milestones[state.activityId][existingMilestoneIndex][key] = milestoneToUpdate[key]
    }
  },

  updateMilestoneBudget (state:IState, budgetUpdate:any){
    //make sure changes to start and end date are saved to the store
    let existingChangeIndex = state.milestoneChanges.findIndex(thisMilestoneUpdate => thisMilestoneUpdate.id == budgetUpdate.id)
    let existingMilestoneIndex = state.milestones[state.activityId].findIndex(thisMilestone => thisMilestone.id == budgetUpdate.id)
    state.milestones[state.activityId][existingMilestoneIndex].budgetChanged = true
    let currentBudget = state.milestones[state.activityId][existingMilestoneIndex].budget
    
    if(currentBudget==null){
      currentBudget = {budgetTemplateId:"",budgetLines:[],activityId:budgetUpdate.id}
      Vue.set(state.milestones[state.activityId][existingMilestoneIndex],'budget', currentBudget)
    }

    if(existingChangeIndex<0){
      state.milestoneChanges.push({
        id:budgetUpdate.id,
        action:"UPDATE",
      })
      existingChangeIndex= state.milestoneChanges.length -1
    }

    for(let key in budgetUpdate){
      if(key == "id"||key=="sectionId")continue
      if(key=="lineItem"){
        //Look for the budgetLineIndex
        let budgetLineIndex = currentBudget.budgetLines.findIndex((thisBudgetLine:any) => thisBudgetLine.lineItemId == budgetUpdate.lineItem.lineItemId)
        //where the budget line index is not found, do a push into budget lines
        if(budgetLineIndex<0){
          state.milestones[state.activityId][existingMilestoneIndex].budget.budgetLines.push({lineValue:budgetUpdate.lineItem.lineValue,lineItemId:budgetUpdate.lineItem.lineItemId})
        }else{
          //where the budget line is found, do an update of that particular budget line
          state.milestones[state.activityId][existingMilestoneIndex].budget.budgetLines[budgetLineIndex].lineValue = budgetUpdate.lineItem.lineValue
        }
      }else{
        if(key=="budgetTemplateId"&&state.milestones[state.activityId][existingMilestoneIndex].budget.budgetTemplateId!=budgetUpdate.budgetTemplateId){
          state.milestones[state.activityId][existingMilestoneIndex].budget.budgetTemplateId = budgetUpdate.budgetTemplateId
        }else{
          state.milestones[state.activityId][existingMilestoneIndex].budget[key] = budgetUpdate[key]
        }
      }
    }
  },

  updateMilestones(state:IState, data:any){
    for(var key in state.milestones){
      state.milestones[key].forEach((thisMilestone,index, milestones) => {
        if (data.data) {
          let indexOfUpdate = data.data.findIndex((thisUpdate:any) => thisUpdate.id == thisMilestone.id)
          if(indexOfUpdate>-1)milestones[index] = data.data[indexOfUpdate]
        }
      })
    }
  },

  deleteMilestone(state: IState, milestoneToDelete: any) {
    let existingChangeIndex = state.milestoneChanges.findIndex(thisMilestoneUpdate => thisMilestoneUpdate.id == milestoneToDelete.id)
    let existingMilestoneIndex = state.milestones[state.activityId].findIndex(thisMilestone => thisMilestone.id == milestoneToDelete.id);
    
    if(existingChangeIndex>-1){
        if(state.milestoneChanges[existingChangeIndex].action=="CREATE"){
            state.milestoneChanges.splice(existingChangeIndex,1)
        }else{
            state.milestoneChanges[existingChangeIndex].action = "DELETE"
        }
        state.milestones[state.activityId].splice(existingMilestoneIndex,1);
    }else{
        state.milestoneChanges.push({
            id:milestoneToDelete.id,
            action:"DELETE",
        })
        state.milestones[state.activityId].splice(existingMilestoneIndex,1);
    }
  },

  updateTempKeyToActual(state:IState,data:any){
    data.forEach((thisTemActualPair:any) => {
      if(thisTemActualPair.tempKey in state.milestones){
        Vue.set(state.milestones,thisTemActualPair.id,state.milestones[thisTemActualPair.tempKey])
        Vue.delete(state.milestones,thisTemActualPair.tempKey)
      }

      if(thisTemActualPair.tempKey == state.activityId){
        state.activityId = thisTemActualPair.id
      }

    })
  },

  clearMilestoneChanges(state:IState,data:any){
    state.milestoneChanges = []
  }
  
}

const actions = {
  getMilestonesForActivity ({ commit,state } : { commit: any,state:IState}) {       
    return new Promise((resolve, reject) => {
        HTTP.get('milestones/?activityId='+state.activityId)
        .then((response: any) => {
            commit('setMilestones', {activityId:state.activityId,data:response.data.data} )         
            resolve(response)                    
        })
        .catch((error: any) => {
            reject(error)
        })
    })
  },
  createMilestonesForActivity({commit}:{commit:any},data:any){
    return new Promise((resolve,reject) => {
        if(data.activities.length>0){
            HTTP.post('milestones/create',data)
            .then((response:any) => {
                commit('updateNewMilestones',{data:response.data.data})
                let tempActualKeyPairs = response.data.data.map((thisMilestone:any) => {return {id:thisMilestone.data.id,tempId:thisMilestone.data.tempKey}})
                resolve({changeType:"CREATE",tempActualKeyPairs})
            })
            .catch((error:any) => {
                reject(error)
            })
        }else{
            resolve([])
        }
    })
  },
  updateMilestonesForActivity({commit}:{commit:any},data:any){
    return new Promise((resolve,reject) => {
        if(data.activities.length>0){
            HTTP.put('milestones/update',data)
            .then((reponse:any) => {
                commit('updateMilestones',{data:reponse.data.data})
                resolve({changeType:"UPDATE"})
            })
            .catch((error:any) => {
                reject(error)
            })
        }else{
            resolve([])
        }
    })
  },
  deleteMilestoneForActivity({commit}:{commit:any},data:any){
    return new Promise((resolve,reject) => {
        if(data.length>0){
            HTTP.delete('milestones/delete',{data: data})
            .then((response:any) => {
                resolve(response)
            })
            .catch((error:any) => {
              reject(error)
            })
        }else{
            resolve([])
        }
    })
  },
  saveChanges({commit,dispatch,state,getters}:{commit:any,dispatch:any,state:IState,getters:any},data:any){

    if(data)commit("updateTempKeyToActual",data)
    
    const allCreateOps:Array<any> = state.milestoneChanges.filter(m => m.action=="CREATE").map(thisEntry => getters.convertMilestoneToMilestoneModel(thisEntry.id))
    const allUpdateOps:Array<any> = state.milestoneChanges.filter(m => m.action=="UPDATE").map(thisEntry => getters.convertMilestoneToMilestoneModel(thisEntry.id))
    const allDeleteOps:Array<any> = state.milestoneChanges.filter(m => m.action=="DELETE").map(thisEntry => thisEntry.id)

    return new Promise((resolve,reject) => {
      dispatch("createMilestonesForActivity",{activities:allCreateOps,type:"List"}).then((tempActualKeyPairs:any) => {
          dispatch("updateMilestonesForActivity",{activities:allUpdateOps,type:"List"}).then((updateRes:any) => {
              dispatch("deleteMilestoneForActivity",allDeleteOps).then((deleteRes:any) => {
                  resolve(tempActualKeyPairs)
              }).catch((error: any) => {
                reject('Failed to delete milestone.')
              })
          }).catch((error: any) => {
            reject('Failed to update milestone.')
          })
      }).catch((error: any) => {
        reject('Failed to create milestone.')
      })
    })  

  }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}